// extracted by mini-css-extract-plugin
export var bannerCustom = "Banner-module--bannerCustom--3d2dc";
export var bannerCustomText = "Banner-module--bannerCustomText--48fc1";